export function compareDates(date1, date2){

    if (new Date(date1).getTime() >= new Date(date2).getTime()){
        return "Día final no puede ser menor a la inicial";
    }

    return '';
}